/**
 * Run reducible of promises in sequence
 */
export const inSequence = (tasks) => {
  return (tasks || []).reduce((p, task) => {
    return p.then(task)
  }, Promise.resolve())
}
